// Shared constants & pure helpers for the 申請履歴 (Submissions History) page.
import { formatDateTime, formatDate as svcFormatDate } from '@/utils/datetime';

export const FORM_TYPES = [
  { value: 'all', key: 'hist.type.all' },
  { value: 'overtime', key: 'hist.type.overtime' },
  { value: 'leave', key: 'hist.type.leave' },
  { value: 'leave_transfer', key: 'hist.type.leave_transfer' },
  { value: 'work_declaration', key: 'hist.type.work_declaration' },
  { value: 'travel_expense', key: 'hist.type.travel_expense' },
];

export const STATUS_OPTIONS = [
  { value: 'all', key: 'hist.status.all' },
  { value: 'awaiting_sign', key: 'hist.status.awaiting_sign' },
  { value: 'awaiting_check', key: 'hist.status.awaiting_check' },
  { value: 'awaiting_approve', key: 'hist.status.awaiting_approve' },
  { value: 'approved', key: 'hist.status.approved' },
];
export const STATUS_VALUES = STATUS_OPTIONS.map((o) => o.value);

export const PIVOT_FORM_COLS = FORM_TYPES.filter((f) => f.value !== 'all');

// Which 締め cycle "YYYY-MM" a date belongs to (dates ≥16 → next month's cycle).
export function cycleOf(d) {
  let y = d.getFullYear();
  let m = d.getMonth() + 1;
  if (d.getDate() >= 16) {
    m += 1;
    if (m > 12) { m = 1; y += 1; }
  }
  return `${y}-${String(m).padStart(2, '0')}`;
}

export function getCurrentCycle() {
  return cycleOf(new Date());
}

export function formTypeLabel(t, type) {
  const found = FORM_TYPES.find((f) => f.value === type);
  return found ? t(found.key) : type;
}

// Localized "2026年7月 (6/16-7/15)" / "2026-07 (6/16-7/15)" cycle label.
export function monthLabel(t, y, m) {
  const prevM = m === 1 ? 12 : m - 1;
  return t('hist.monthLabel', { y, m, m2: String(m).padStart(2, '0'), pm: prevM });
}

// Extract each form type's representative "start date" (the date the form
// actually targets, not when it was submitted).
export function getFormStartDate(sub) {
  const fd = sub.form_data || {};
  switch (sub.form_type) {
    case 'overtime':         return fd.date;
    case 'leave':            return fd.leave_date;
    case 'leave_transfer':   return fd.holiday_date || fd.work_date;
    case 'work_declaration': return fd.occurrence_date;
    case 'travel_expense':   return fd.travel_start_date;
    default:                 return null;
  }
}

export function formatDate(isoString) {
  return formatDateTime(isoString);
}

// For form start dates we only have a calendar date (no time).
export function formatDateOnly(value) {
  if (!value) return '—';
  return svcFormatDate(value) || value;
}
